import { DataCenter } from "./DataCenter";
import { CatVo } from "./dataObjects/CatVo";
import { SubCatVo } from "./dataObjects/SubCatVo";
import { TopicVo } from "./dataObjects/TopicVo";
import { MainStorage } from "./MainStorage";

export class TreeLoader {
    public callback: Function;
    private subjectID: number=0;
    private ms:MainStorage=MainStorage.getInstance();
    constructor(callback: Function) {
        this.callback = callback;
    }
    public loadTree(subjectID: number) {
        this.subjectID = subjectID;
        DataCenter.getTree(subjectID, this.onTreeLoaded.bind(this));
    }
    private onTreeLoaded(data: any) {
        if (this.ms.subjectID===1)
        {
            this.onLangLoaded(data);
            return;
        }
        console.log(data);
        let branches:CatVo[]=[];
        for (let i:number=0; i<data.tree.length; i++) {
            let branch:any=data.tree[i];
            let catVo:CatVo=new CatVo(branch.id, this.subjectID, branch.catName);
            branches.push(catVo);
            //loop through subcats
             for (let j:number=0; j<branch.subcats.length; j++) {
                let subcat:any=branch.subcats[j];
               
                let subCatVo:SubCatVo=new SubCatVo(subcat.id, subcat.subCatName);
                subCatVo.slug=subcat.slug;
                catVo.subcats.push(subCatVo);

                //loop through topics
                for (let k:number=0; k<subcat.topics.length; k++) {
                    let topic:any=subcat.topics[k];
                    //console.log(topic);
                    let topicVo:TopicVo=new TopicVo(parseInt(topic.id), this.subjectID,topic.pname,parseInt(topic.level));
                    topicVo.slug=subCatVo.slug;
                    topicVo.blurb=topic.blurb;
                    topicVo.catID=parseInt(topic.catID);
                    topicVo.subCatID=parseInt(topic.subCatID);
                    subCatVo.topics.push(topicVo);
                    //console.log(topicVo);
                }
            } 
        }
      console.log(branches);
        this.callback(branches);
    }
    private onLangLoaded(data: any) {
        //langage does not have subcats
        console.log(data);
        let branches:CatVo[]=[];
        for (let i:number=0; i<data.tree.length; i++) {
            let branch:any=data.tree[i];
            let catVo:CatVo=new CatVo(branch.id, this.subjectID, branch.catName);
            branches.push(catVo);
            for (let j:number=0; j<branch.topics.length; j++) {
                let topic:any=branch.topics[j];
                let topicVo:TopicVo=new TopicVo(parseInt(topic.id), this.subjectID,topic.title,parseInt(topic.level));
                topicVo.slug=branch.slug;
                topicVo.blurb=topic.blurb;
                topicVo.icon=topic.icon;
                topicVo.difficulty=parseInt(topic.difficult);
                catVo.topics.push(topicVo);
            }
        }
        this.callback(branches);
    }
}
/* 
: { "tree": [{ "id": "1", "catName": "British History", "icon": "hist/tower-of-london", "slug": "hist-british-history", "ready": "1", "active": "1", "subcats": [{ "id": "1", "catID": "1", "subCatName": "Roman Britain", "icon": "hist/brit/boudica", "prompt": "", "slug": "sc-hist-roman-britain", "ready": "1", "active": "1", "topics": [{ "id": "58", "subCatID": "1", "pname": "The Roman Conquest of Britain (43 AD)", "minGames": "3", "winPer": "70", "dorder": "1", "prompt": "", "context": "", "blurb": "Experience the epic tale of The Roman Conquest of Britain in 43 AD, as Julius Caesar's legions set foot on foreign shores, facing fierce Celtic tribes and treacherous terrain. Witness the clash of civilizations and the birth of a new era in this gripping historical account of conquest and resistance.", "slug": "roman-conquest-britain", "pageLink": "", */